import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";
import { MsEventSharedLayout } from "../_components/ms-events-shared-layout";
import { EventInfo } from "./_components/event-info";
import { withBranding } from "@/utils/helper";

export const MSEventDetailsPage = () => {
  const { t } = useTranslation("my-space");
  usePageTitle(withBranding(t("page_titles.event_details")));
  return (
    <MsEventSharedLayout>
      <EventInfo />
    </MsEventSharedLayout>
  );
};
